import { render } from "./PlanilhaPedidos.vue?vue&type=template&id=55f7cceb&scoped=true"
import script from "./PlanilhaPedidos.vue?vue&type=script&lang=js"
export * from "./PlanilhaPedidos.vue?vue&type=script&lang=js"

import "./PlanilhaPedidos.vue?vue&type=style&index=0&id=55f7cceb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f7cceb"]])

export default __exports__